





































import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
// import {Chat} from 'vue-quick-chat';
// import 'vue-quick-chat/dist/vue-quick-chat.css';
import Chat from 'vue-quick-chat/src/components/Chat.vue';

@Component({
  components: {
    Chat,
  },
})
export default class ChatBox extends Vue {
  @Prop({ type: Boolean }) dailog!: boolean;

  @Prop({ type: Object }) doc!: object;

  componentKey = 0;

  mounted() {
    this.$store.dispatch('bindChatRoom');
  }

  myself = {
    name: this.currentUser.display,
    id: this.currentUser.uid,
  };

  chatTitle = 'My chat';

  placeholder = 'send your message';

  colors = {
    header: {
      bg: '#F04B37',
      text: '#fff',
    },
    message: {
      myself: {
        bg: '#8AE38A',
        text: '#fff',
      },
      others: {
        bg: '#98B0CA',
        text: '#fff',
      },
      messagesDisplay: {
        bg: '#f7f3f3',
      },
    },
    submitIcon: '#F04B37',
    submitImageIcon: '#F04B37',
  };

  hideCloseButton = false;

  submitIconSize = 25;

  closeButtonIconSize = '20px';

  asyncMode = false;

  toLoad = [
    {
      content: 'Hey, John Doe! How are you today?',
      myself: false,
      participantId: 2,
      timestamp: {
        year: 2011,
        month: 3,
        day: 5,
        hour: 10,
        minute: 10,
        second: 3,
        millisecond: 123,
      },
      uploaded: true,
      viewed: true,
      type: 'text',
    },
    {
      content: 'Lets start your chat!',
      myself: true,
      participantId: 3,
      timestamp: {
        year: 2010,
        month: 0,
        day: 5,
        hour: 19,
        minute: 10,
        second: 3,
        millisecond: 123,
      },
      uploaded: true,
      viewed: true,
      type: 'text',
    },
  ];

  scrollBottom = {
    messageSent: false,
    messageReceived: false,
  };

  displayHeader = true;

  profilePictureConfig = {
    others: true,
    myself: true,
    styles: {
      width: '30px',
      height: '30px',
      borderRadius: '50%',
    },
  };

  timestampConfig = {
    format: 'HH:mm',
    relative: true,
  };

  // there are other options, you can check them here
  // https://soapbox.github.io/linkifyjs/docs/options.html
  linkOptions = {
    myself: {
      className: 'myLinkClass',
      events: {
        click: (e: any) => {
          alert('Link clicked!');
        },
        mouseover: (e: any) => {
          alert('Link hovered!');
        },
      },
      format: (value: any, type: any) => {
        if (type === 'url' && value.length > 50) {
        //   value = value.slice(0, 50) + '…';
        }
        return value;
      },
    },
    others: {
      className: 'othersLinkClass',
      events: {
        click: (e: any) => {
          alert('Link clicked!');
        },
        mouseover: (e: any) => {
          alert('Link hovered!');
        },
      },
      format: (value: any, type: any) => {
        if (type === 'url' && value.length > 50) {
          // value = value.slice(0, 50) + '…';
        }
        return value;
      },
    },
  };

  loadMoreMessages= (resolve: any) => {
    // setTimeout(() => {
    //   resolve(this.toLoad);
    //   // this.messages.push(...this.toLoad);
    //   // this.toLoad = [];
    // }, 1000);
  }

  parsedmsg(msg: any) {
    return {
      participantId: this.currentUser.uid,
      content: msg.content,
      time: new Date(),
    };
  }

  onMessageSubmit = (message: any) => {
    const doc1 = this.doc as any;
    doc1.messages.push(this.parsedmsg(message));
    this.$store.dispatch('updateChatRoom', {
      collection: 'chatRooms',
      payload: doc1,
    });
  };

  get messages() {
    const doc1 = this.doc as any;
    if (this.$store.state.chatRooms.find((doc: any) => (
      doc.id === doc1.id))) {
      const room = this.$store.state.chatRooms.find((doc: any) => (
        doc.id === doc1.id));
      this.doc = room;
      const messages1 = [] as any;
      room.messages.forEach((msg: any) => {
        const cloneObj = {
          content: msg.content,
          myself: (this.currentUser.uid === msg.participantId),
          participantId: msg.participantId,
        };
        messages1.push(cloneObj);
      });
      // return messages1.slice().sort((a: any, b: any) => b.time - a.time);
      // return messages1;
      return messages1.slice().sort((a: any, b: any) => b.time - a.time);
    }
    return [];
  }

  get participants() {
    const doc = this.doc as any;
    return doc.participants;
  }

  onClose() {
    this.dailog = false;
  }

  onImageSelected(files: any, message: any) {
    const src = 'https://149364066.v2.pressablecdn.com/wp-content/uploads/2017/03/vue.jpg';
    this.messages.push(message);
    /**
     * This timeout simulates a requisition that uploads the image file to the server.
     * It's up to you implement the request and deal with the response in order to
     * update the message status and the message URL
     */
    setTimeout(
      (res: any) => {
        // eslint-disable-next-line
        message.uploaded = true;
        // eslint-disable-next-line
        message.src = res.src;
      },
      3000,
      { src },
    );
  }

  onImageClicked= (message: any) => {
    /**
     * This is the callback function that is going to be executed when some image is clicked.
     * You can add your code here to do whatever you need
     * with the image clicked. A common situation is to display the image clicked in full screen.
     */
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }

  get user() {
    const doc1 = this.doc as any;
    return doc1.participants.find((user: any) => (user.id !== this.currentUser.uid));
  }

  get changes() {
    const doc1 = this.doc as any;
    return this.$store.state.chatRooms.find((doc: any) => (doc.id === doc1.id));
  }

  @Watch('changes')
  // eslint-disable-next-line class-methods-use-this
  onPropertyChanged(value: any, oldValue: any) {
    // this.componentKey += 1;
  }
}
